import cn from 'classnames';
import { useRouter } from 'next/router';
import { memo } from 'react';
import { TOTAL_PAGINATION } from 'src/constants';
import { useClient } from 'src/hooks';
import { UrlUtils } from 'src/utils';
import { Element, IconButton, RouterLink } from 'src/components';

interface IProps {
    startPage: number;
    currentPage: number;
    isFetching: boolean;
    hasMore: boolean;
    showButtonLoadMore?: boolean;
    loaderRef: any;
}

const parseUrl = (path: string) => {
    if (typeof path !== 'string') return '';

    const removeQuery = path.split('?')[0];
    if (removeQuery === '/') return '';

    const pathArr = removeQuery?.replace('.epi', '').split('/trang');
    return pathArr[0];
};

const LoadMore = ({
    isFetching,
    currentPage,
    hasMore,
    showButtonLoadMore = true,
    startPage,
    loaderRef,
}: IProps) => {
    const router = useRouter();

    const { isClient } = useClient();
    const pagination = isClient ? TOTAL_PAGINATION : -1;
    const showPrevBtn = Number(router.query?.page) > 1;
    const showButtons = currentPage >= startPage + pagination && hasMore;
    const pathname = parseUrl(router.asPath);
    const nextUrl =
        `${pathname}/trang${startPage + pagination + 1}.epi` +
        UrlUtils.getQueryString(router.asPath);

    const prevPage = startPage - 2;
    const prevUrl =
        (prevPage === 1
            ? pathname
                ? `${pathname}.epi`
                : '/'
            : `${pathname || ''}/trang${prevPage}.epi`) +
        UrlUtils.getQueryString(router.asPath);

    return (
        <>
            {showButtonLoadMore && !isFetching && (
                <Element
                    className={cn('load-more', 'flex justify-center my-[15px]')}
                >
                    {showPrevBtn && (
                        <RouterLink to={prevUrl}>
                            <IconButton
                                className={cn(
                                    'text-[1.6rem] uppercase',
                                    'h-[32px]',
                                    'px-[20px] py-0 mx-[5px]',
                                    'rounded-[0.25rem]',
                                    'text-[var(--primary)]',
                                    'bg-[#f7f8f9]',
                                    'border border-solid border-[#f2f4f5]',
                                )}
                                title="Quay lại"
                                outlined={true}
                                text="Quay lại"
                            />
                        </RouterLink>
                    )}
                    {showButtons && (
                        <RouterLink to={nextUrl}>
                            <IconButton
                                className={cn(
                                    'text-[1.6rem] uppercase',
                                    'h-[32px]',
                                    'px-[20px] py-0 mx-[5px]',
                                    'rounded-[0.25rem]',
                                )}
                                title="Xem thêm"
                                text="Xem thêm"
                                color="primary"
                            />
                        </RouterLink>
                    )}
                </Element>
            )}
            {hasMore && !isFetching && !showButtons && (
                <div
                    ref={loaderRef}
                    style={{ marginTop: '100px', height: '1px' }}
                ></div>
            )}
        </>
    );
};

export default memo(LoadMore);
